import { Drawer } from 'antd';
import { ReconciliationStatementForm } from 'components/DocumentForms/ReconciliationStatementForm';

function ActSverkiForm({
  isActive,
  initialValues,
  copyDocId,
  clientId,
  clientInfo,
  onClose,
  onSuccess,
}) {
  const isEditing = initialValues !== null;

  const handleConfirm = () => {
    onClose();
  };

  return (
    <Drawer
      title={
        isEditing
          ? `Редактирование документа (Акт Сверки)`
          : `Создание документа (Акт Сверки)`
      }
      width="90%"
      onClose={() => onClose()}
      open={isActive}
      getContainer={false}
    >
      <div style={{ maxWidth: '100%', overflow: 'auto' }}>
        <ReconciliationStatementForm
          initialValues={initialValues}
          clientId={clientId}
          clientInfo={clientInfo}
          copyDocId={copyDocId}
          isActive={isActive}
          onSuccess={onSuccess}
          onConfirm={handleConfirm}
        />
      </div>
    </Drawer>
  );
}

export { ActSverkiForm };
